import { SET_IS_EMBEDDED } from "../types/embeddedType";

export const setIsEmbedded = (data) => (dispatch) => {
    dispatch({
        type: SET_IS_EMBEDDED, 
        payload: data 
    })
};

